module.exports = __webpack_public_path__ + "static/media/unit.713c4fdf.png";